export default __webpack_public_path__ + "static/custom-software-86e65496abd81656c43564ee26408bf0.webp";